import styled from "styled-components";

export const TransparentContainer = styled.div`
  width: 100vh;
  height: 100vw;
  background-color: red;
`;

export const Content = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MainContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TitleContainer = styled.div`
  width: 100%;
  height: 70px;
  background-color: #104467;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  span {
    color: white;
    font-weight: 600;
    font-size: 1.4rem;
  }
`;

export const FiltersContainer = styled.div`
  padding: 30px 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1400px) {
    padding: 20px 2%;
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    padding: 20px 5%;
    height: fit-content;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  @media (max-width: 670px) {
    flex-direction: column;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  text-align: center;
`;

export const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const CardsContainer = styled.div`
  flex: 1;
  background-color: #edf1f6;
  padding: 30px 10%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  justify-content: center;
  align-items: center;
  place-items: center;

  @media (max-width: 1400px) {
    padding: 0 2%;
  }

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    padding: 20px 5%;
    height: fit-content;
  }

  @media (max-width: 830px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 565px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const OportunityCard = styled.div`
  background-color: white;
  width: 250px;
  border-radius: 5px;
  padding: 20px;
  height: fit-content;
`;
